import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79039020&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79039020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79039020",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxTabTitle: require('/drone/src/components/OrderBox/OrderBoxTabTitle.vue').default,FilterDropdown: require('/drone/src/components/FilterDropdown/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,GoodsCard: require('/drone/src/components/GoodsCard/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
